<template>
  <div id="app">
    <router-view/>
<!--    <van-image-preview v-model="show" :images="imagesList" @change="onChange" :closeable="true" @close="closew">-->
<!--    </van-image-preview>-->
  </div>
</template>

<script>
  // import {mapGetters,mapActions} from 'vuex'
export default {
  name: 'App',
  data(){
    return {
      index:0,
      show:false
    }
  },
  watch:{
    // showIMG(a){
    //   // console.log(a)
    //   this.show=a
    // }
  },
  mounted() {

  },
  computed: {
    // ...mapGetters(['showIMG','imagesList'])
  },
  methods:{
    // ...mapActions(['setShowIMG','setImagesList']),
    // closew(){
    //   // console.log(111)
    //   this.setShowIMG(false)
    //   this.setImagesList([])
    // },
    // onChange(index) {
    //   this.index = index;
    // }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /*margin-top: 50px;*/
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue